import FTourDictionary from '@/modules/Tour/Dictionary/index';
import core from "@/core";

export default class FTourDictionaryPartner extends FTourDictionary {
  dictionary = 'OwnerLegal';

  constructor(props = {}) {
    super(props);
    this.partner = core.account.partner;
  }
  __formatting({partnerLegals = []}) {
    return super.__formatting(partnerLegals);
  }
}
